module.exports = __webpack_public_path__ + "svg_80x80/HTML5.64a31d.svg";